(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csutom-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Avoid double-registering this once-per-page script if Shopify re-renders
  if (window.__mediaTextScrollSoundInit) {
    window.__mediaTextScrollSoundInit();
    return;
  }

  function initMediaTextScrollSound(root) {
    root = root || document;

    var sections = root.querySelectorAll('.media-text-section[data-scroll-sound-toggle="true"]');

    sections.forEach(function (sectionEl) {
      // Skip if we already wired this exact section instance
      if (sectionEl.dataset.scrollSoundWired === 'true') return;
      sectionEl.dataset.scrollSoundWired = 'true';

      var videoEl = sectionEl.querySelector('video');
      var iframeEl = sectionEl.querySelector('[data-youtube-player]');

      if (!videoEl && !iframeEl) return;

      function postToYoutube(func) {
        if (!iframeEl || !iframeEl.contentWindow) return;
        try {
          iframeEl.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: func, args: [] }),
            '*'
          );
        } catch (e) {
          /* no-op: player not ready yet */
        }
      }

      function unmute() {
        if (videoEl) {
          videoEl.muted = false;
          var playPromise = videoEl.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              // Browser blocked unmuted autoplay without prior user gesture.
              // Fall back to muted so playback doesn't stop entirely.
              videoEl.muted = true;
              videoEl.play().catch(function () {});
            });
          }
        }
        if (iframeEl) {
          postToYoutube('unMute');
          postToYoutube('playVideo');
        }
      }

      function mute() {
        if (videoEl) {
          videoEl.muted = true;
        }
        if (iframeEl) {
          postToYoutube('mute');
        }
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              unmute();
            } else {
              mute();
            }
          });
        },
        {
          root: null,
          threshold: [0, 0.5, 1]
        }
      );

      observer.observe(sectionEl);
    });
  }

  // Expose a re-init hook for Shopify theme editor section re-renders
  window.__mediaTextScrollSoundInit = initMediaTextScrollSound;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMediaTextScrollSound(document);
    });
  } else {
    initMediaTextScrollSound(document);
  }

  // Re-run whenever the theme editor swaps this section back in
  document.addEventListener('shopify:section:load', function (event) {
    initMediaTextScrollSound(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
